module.exports = __webpack_public_path__ + "media/davide-voice.23d90baf.wav";